import type { State, Actions } from './typings'

import {
  setCustomerProducer,
  setDiscountProducer,
  setEmployeeProducer,
  setOtherProducer,
  setReferralTypeProducer,
  setReferralProducer,
  clearCustomerProducer,
  initializeProducer,
} from './actions'

export function reducer(state: State, action: Actions) {
  switch (action.type) {
    case 'referrals/setReferralType':
      return setReferralTypeProducer(state, action.payload)
    case 'referrals/setDiscount':
      return setDiscountProducer(state, action.payload)
    case 'referrals/setCustomer':
      return setCustomerProducer(state, action.payload)
    case 'referrals/setReferral':
      return setReferralProducer(state, action.payload)
    case 'referrals/setEmployee':
      return setEmployeeProducer(state, action.payload)
    case 'referrals/setOther':
      return setOtherProducer(state, action.payload)
    case 'referrals/clearCustomer':
      return clearCustomerProducer(state)
    case 'referrals/initialize':
      return initializeProducer()
    default:
      return { ...state }
  }
}
